import SellsukiProvider from '@/resources/sellsuki_provider'
import OrderProvider from '@/resources/order_provider'
const orderProvider = new OrderProvider()
const sellsukiProvider = new SellsukiProvider()

const state = {
  sellsukiData: {},
  branch: [],
  initailData: {},
  paymentChannel: [],
  billExpire: 1,
  storeData: {},
  mainColor: '#1b0000'
}

const actions = {
  setSellsukiAuth ({commit}, payload) {
    commit('SET_AUTH_SELLSUKI', payload)
  },
  setMainColor ({ commit }, payload) {
    commit('SET_MAIN_COLOR', payload)
  },
  async fetchBranch ({commit}) {
    const results = await sellsukiProvider.fetchBranch()
    commit('SET_BRANCH', results)
  },
  async init ({ commit }) {
    const { billExpire, paymentChannel, initData } = await orderProvider.init()
    commit('SET_INITAIL_DATA', initData)
    commit('SET_PAYMENT_CHANNEL', paymentChannel)
    commit('SET_BILL_EXPIRE', billExpire)
  }
}

const mutations = {
  SET_MAIN_COLOR: (state, payload) => {
    state.mainColor = payload
  },
  SET_AUTH_SELLSUKI: (state, payload) => {
    state.sellsukiData = payload
  },
  SET_BRANCH: (state, payload) => {
    state.branch = payload
  },
  SET_INITAIL_DATA: (state, payload) => {
    state.initailData = payload
  },
  SET_PAYMENT_CHANNEL: (state, payload) => {
    state.paymentChannel = payload
  },
  SET_BILL_EXPIRE: (state, payload) => {
    state.billExpire = payload
  }
}

const getters = {
  mainColor: (state) => state.mainColor,
  storeName: (state) => state.initailData.store ? state.initailData.store.store_name : '',
  storeColor: (state) => state.initailData.store ? state.initailData.store.store_display_photo : '',
  getSellsukiAuth: (state) => {
    return state.sellsukiData
  },
  getBranch: (state) => {
    return state.branch
  },
  storeId: (state) => {
    return state.initailData.store.id
  },
  initailData: state => state.initailData,
  storeData: state => state.initailData,
  paymentChannel: state => state.paymentChannel,
  billExpire: state => state.billExpire
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sellsukiData.js